import { User } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import MainLayout from '../components/MainLayout';
import { auth } from '../firebaseSetup';
import { Paths } from './paths';

const ProtectedRoute = () => {
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    auth.authStateReady().then(() => {
      const currentUser = auth.currentUser;
      setUser(currentUser);
      if (!currentUser) {
        console.warn('User not logged in');
        navigate(Paths.Login);
      }
    });
  }, [navigate]);

  return user ? <MainLayout user={user} /> : <Loading />;
};

export default ProtectedRoute;
